import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="overflow-hidden border-t border-black/10 px-5 pt-20 md:px-10">
    <div className="mx-auto flex max-w-[1400px] flex-col justify-between gap-8 md:flex-row">
      <div className="flex items-center gap-3">
        <LogoMark className="h-12 w-12" />
        <p className="max-w-xs text-sm text-stone-700">Your independent off-licence. Please drink responsibly — drinkaware.co.uk</p>
      </div>
      <p className="font-mono-g text-xs uppercase tracking-[0.2em] text-stone-600">© {new Date().getFullYear()} Guna Stores · No sale of alcohol to under 18s</p>
    </div>
    <p className="font-display mt-10 select-none text-center text-[26vw] leading-[0.8] tracking-[-0.04em] text-[#D62828]/[0.08]" aria-hidden="true">Guna</p>
  </footer>
);
